export { default } from "./ConditionName";
